import { ArrayOps } from '../lift';
/**
 * Returns whether at least one item satisfies the predicate.
 */
export function some(predicate) {
    var arr = this.value();
    for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i], i))
            return true;
    }
    return false;
}
ArrayOps.prototype.some = some;
